import { isSignal } from "@angular/core";
import { OPTIONS_GROUPED_BY_HOST } from "./supported_component";
import { arrayUnique } from '@core/shared/utils';
import * as i0 from "@angular/core";
export let UiInputOptionsGroupedByirective = /*#__PURE__*/(() => {
  class UiInputOptionsGroupedByirective {
    // will be set by InputOptionsDynamic.
    // Or set manually if you want to use it without InputOptionsDynamic.
    set options(data) {
      this._options = data;
      this.transformData();
      this.applyData();
    }
    constructor(component) {
      this.component = component;
      this.config = null;
    }
    transformData() {
      const config = this.config;
      if (config === null) return;
      const selectItemGroups = [];
      if (!config.groupProp) throw new Error('cannot apply OptionsGroupedBy, input data misses groupProp!');
      const addOptionToGroup = (opt, selectItemGroups) => {
        if (!opt) return;
        const groupInfo = opt[config.groupProp];
        let group = this.findGroup(groupInfo, selectItemGroups);
        if (!group) group = this.findOrCreateOthersGroup(selectItemGroups);
        group.items.push(opt);
      };
      if (config.groups) {
        config.groups.filter(g => !!g).forEach(group => {
          this.createGroup(group, selectItemGroups);
        });
        this._options.forEach(opt => addOptionToGroup(opt, selectItemGroups));
      } else {
        const groupInfosUniqueAndOrdered = this.collectGroupsFromOptions(this._options);
        groupInfosUniqueAndOrdered.filter(g => !!g).forEach(info => {
          const subGroup = this.createGroup(info, []);
          if (subGroup) selectItemGroups.push(subGroup);
        });
        this._options.forEach(opt => addOptionToGroup(opt, selectItemGroups));
      }
      this.transformedData = selectItemGroups;
    }
    collectGroupsFromOptions(options) {
      const groupInfos = options.filter(opt => !!opt[this.config.groupProp]).map(opt => opt[this.config.groupProp]);
      const isStringArray = typeof groupInfos[0] === 'string';
      let uniqueGroups = [];
      if (isStringArray) {
        uniqueGroups = arrayUnique(groupInfos);
      } else {
        if (this.config.groupDataKey) {
          // build unique group list by comparing by groupDataKey
          groupInfos.forEach(groupInfo => {
            const match = uniqueGroups.find(comparedGroup => {
              return comparedGroup[this.config.groupDataKey] === groupInfo[this.config.groupDataKey];
            });
            if (!match) uniqueGroups.push(groupInfo);
          });
        } else {
          // strict matching
          uniqueGroups = arrayUnique(groupInfos);
        }
        uniqueGroups = uniqueGroups;
      }
      return this.applyOrdering(uniqueGroups);
    }
    applyOrdering(groups) {
      if (this.config.groupOrdering) {
        if (typeof this.config.groupOrdering === 'function') {
          groups.sort(this.config.groupOrdering);
        } else {
          const {
            field,
            direction
          } = this.config.groupOrdering;
          groups.sort((a, b) => {
            const aIsGreater = a[field] > b[field];
            return direction === 'ASC' ? aIsGreater ? 1 : -1 : aIsGreater ? -1 : 1;
          });
        }
        return groups;
      } else {
        return groups;
      }
    }
    findGroup(groupInfo, selectItemGroups) {
      if (groupInfo && selectItemGroups.length) {
        if (typeof groupInfo === 'string') {
          const match = selectItemGroups.find(group => group.value === groupInfo);
          if (match) return match;
        } else {
          const value = this.config.groupDataKey ? groupInfo[this.config.groupDataKey] : groupInfo;
          const match = selectItemGroups.find(group => group.value === value);
          if (match) return match;
        }
      }
      return null;
    }
    findOrCreateOthersGroup(selectItemGroups) {
      const groupInfo = "Andere";
      let group = this.findGroup(groupInfo, selectItemGroups);
      if (!group) group = this.createGroup(groupInfo, selectItemGroups);
      return group;
    }
    createGroup(groupInfo, selectItemGroups) {
      let newGroup;
      if (typeof groupInfo === 'string') {
        newGroup = {
          label: groupInfo,
          value: groupInfo,
          items: []
        };
      } else {
        const value = this.config.groupDataKey ? groupInfo[this.config.groupDataKey] : groupInfo;
        const label = groupInfo[this.config.groupLabelKey || 'name'];
        newGroup = {
          label,
          value,
          items: []
        };
      }
      selectItemGroups.push(newGroup);
      return newGroup;
    }
    applyData() {
      if (this.config === null) {
        this.component.group = false;
      } else {
        this.component.group = true;
      }
      if (isSignal(this.component.options)) {
        if (this.config === null) {
          this.component.options.set(this._options);
        } else {
          this.component.options.set(this.transformedData);
        }
      } else {
        if (this.config === null) {
          this.component.options = this._options;
        } else {
          this.component.options = this.transformedData;
        }
      }
      this.component.markForCheck();
    }
    static {
      this.ɵfac = function UiInputOptionsGroupedByirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiInputOptionsGroupedByirective)(i0.ɵɵdirectiveInject(OPTIONS_GROUPED_BY_HOST, 2));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: UiInputOptionsGroupedByirective,
        selectors: [["", "InputOptionsGroupedBy", ""]],
        inputs: {
          config: [0, "InputOptionsGroupedBy", "config"],
          options: [0, "InputOptionsGroupedByData", "options"]
        }
      });
    }
  }
  return UiInputOptionsGroupedByirective;
})();